var map = {
	"./arcade_large.png": 9205,
	"./background.png": 8462,
	"./bronzeOg_400.png": 6674,
	"./carlosBG.png": 4712,
	"./carlosdemo.png": 6192,
	"./chest.png": 1768,
	"./chest_M.png": 2827,
	"./chest_S.png": 6709,
	"./coin.png": 2602,
	"./congrats.png": 8940,
	"./demo.png": 3717,
	"./diamondOg_400.png": 1443,
	"./flockBG.png": 9638,
	"./footer.png": 9604,
	"./gem.png": 3524,
	"./gift.png": 9749,
	"./goldOg_400.png": 1054,
	"./itemBottle.png": 5898,
	"./landingbg.png": 8911,
	"./legendaryOg_400.png": 4085,
	"./loading.gif": 9292,
	"./metamask-icon.webp": 8311,
	"./pcdemo.png": 2345,
	"./pig.png": 823,
	"./season1_400.png": 3666,
	"./silverOg_400.png": 7080,
	"./star.png": 24
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;